// =============================================================================
// HEADER — Sticky scroll behavior
// =============================================================================

export function initHeader() {
  const nav = document.getElementById('mainNav');
  if (!nav) return;

  const SCROLL_THRESHOLD = 60;
  const isHomePage = document.body.classList.contains('page-home');

  const updateHeader = () => {
    if (!isHomePage || window.scrollY > SCROLL_THRESHOLD) {
      nav.classList.add('scrolled');
    } else {
      nav.classList.remove('scrolled');
    }
  };

  // Throttle scroll handler
  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(() => {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }, { passive: true });

  // Run on load in case page is already scrolled
  updateHeader();

  // Close mobile menu on nav link click
  const navLinks = nav.querySelectorAll('.nav-link');
  const navCollapse = document.getElementById('navbarMain');

  navLinks.forEach(link => {
    link.addEventListener('click', () => {
      if (navCollapse && navCollapse.classList.contains('show')) {
        const bsCollapse = bootstrap.Collapse.getInstance(navCollapse);
        if (bsCollapse) bsCollapse.hide();
      }
    });
  });

  // Mobile menu open state for background
  if (navCollapse) {
    navCollapse.addEventListener('show.bs.collapse', () => {
      nav.classList.add('navbar-mobile-open');
    });
    navCollapse.addEventListener('hide.bs.collapse', () => {
      nav.classList.remove('navbar-mobile-open');
    });
  }
}
